import { render, staticRenderFns } from "./EmbroideryController.vue?vue&type=template&id=1d7b4e45&"
import script from "./EmbroideryController.vue?vue&type=script&lang=js&"
export * from "./EmbroideryController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports